module.exports = __webpack_public_path__ + "img/鳖甲.489836f7.jpg";